import { CheckCircle2, XCircle, AlertTriangle, Info, X } from 'lucide-react';
import { useToasts, toast, type ToastTone } from './toast';
import { cn } from '../lib/cn';

const toneConf: Record<ToastTone, { icon: typeof Info; color: string }> = {
  success: { icon: CheckCircle2, color: 'text-success' },
  error: { icon: XCircle, color: 'text-danger' },
  warning: { icon: AlertTriangle, color: 'text-warning' },
  info: { icon: Info, color: 'text-info' },
};

/** Контейнер тостов (top-right, как на макетах). aria-live для скринридеров. */
export function Toaster() {
  const items = useToasts();
  return (
    <div
      className="pointer-events-none fixed right-4 top-4 z-[100] flex w-[min(22rem,calc(100vw-2rem))] flex-col gap-2"
      aria-live="polite"
      role="status"
    >
      {items.map((t) => {
        const { icon: Icon, color } = toneConf[t.tone];
        return (
          <div
            key={t.id}
            className="pointer-events-auto flex items-start gap-3 rounded-xl border border-border bg-surface p-3.5 shadow-pop"
          >
            <Icon className={cn('mt-0.5 h-5 w-5 shrink-0', color)} />
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-fg">{t.title}</p>
              {t.description && <p className="mt-0.5 text-xs text-fg-muted">{t.description}</p>}
            </div>
            <button
              type="button"
              onClick={() => {
                toast.dismiss(t.id);
              }}
              aria-label="Закрыть"
              className="shrink-0 text-fg-muted hover:text-fg"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
